// OptionSelectorsCustom is onlky required when using custom handlebar options.
import OptionSelectorsCustom from './variants.custom';

theme.variants = {
    
    // The variants we want to display to human beings.
    visibleOptions: ['Size', 'size'],

    // The variants <select>
    container: '.product-select',

    // Boot
    init: function(ajax) {
        
        // Logging.
        if (theme.debugging) {
            if (ajax) {
                console.info('%c[Sureify Variants] ----- Initialising (AJAX)', 'color: #4edfcb;')
            } else {
                console.info('%c[Sureify Variants] ----- Initialising', 'color: #ff3900;')
            }
        }  

        /*
            Uncomment the below if you wish to use
            dropdown <selects>, and remove the hash from
            this.container as OptionSelectors() doesn't
            use this.
            
            new Shopify.OptionSelectors(this.container, { 
                product: theme.productData, 
                onVariantSelected: this.callback 
            });    
        */

        let that = this
        let html = $('#option-selector-template').html()
        
        $.each($(theme.variants.container), function() {

            // Get the product data (json)
            let product = $(this).data('product-data')
			
			// Get sizeguide class
			let sizeguide_class = $(this).data('sizeguide-class')
            
            // Select all product <select> dropdowns with by appropriate class
            let element = ".product-select-" + $(this).data('product-id')
            
            // Catch that a small mini template should be compiled
            if ($(element).data('template') == 'mini') {
                html = $('#option-selector-template-mini').html()
            }

            // Is history enabled or not?
            let history = theme.isProductTemplate
            let recommendation = $(this).attr('data-product-recommendation')
            if (typeof recommendation !== 'undefined' && recommendation !== false) {
                history = false
            }

            let options = $(element).parent().find('[data-options-select]')
            if (options.length == 0) {
                new OptionSelectorsCustom({
                    // The select box ID to target
                    element: element,
                    // The product's JSON
                    product: product,
                    // Turn on history event (updates history with variant selected and updates URL)
                    enableHistory: history ? true : false,
                    // The class to set active when a customer clicks an item
                    selectedClass: 'active',
                    // The callback to fire when a selection is made
                    // Values passed:
                    //    {Object} variant The variant object
                    //    {Object} e The mouse event which fired the click
                    callback: that.callback,
                    // The template's HTML (Handlebars example)
                    template: Handlebars.compile(html),
                    // The handler for building each selector (template specific, Handlebars example)
                    templateBuilder: function () { 
                        // Hide other variants options
                        let option_hidden = true
                        if (theme.variants.visibleOptions.includes(this.name)) {
                            option_hidden = false
                        }
                        let data = {
                            option_id: this.id,
                            option_name: this.name,
                            option_values: this.values,
                            product_variants: this.product.variants,
                            product_id: this.product.id,
                            product_inventory : this.product.available,
                            option_hidden : option_hidden,
							sizeguide_class: sizeguide_class
                        }
                        return this.template(data);
                    }
                })
            }
        
        });

        // Setup UI
        theme.variants._createUI();

    },

    // Callback
    callback: function(variant, event) {

        let $context = $(this.elem).closest('form')
        
        
        if (variant) {
            
            if (variant.available) {

                $context.find('[data-product-delivery-estimate]').removeClass('hidden')

                // Selected a valid variant that is available.
                $context.find('[data-add-to-cart]')
                    .removeClass('bg-grey opacity-50 cursor-not-allowed')
                    .removeAttr('disabled')
                    .fadeTo(200,1);

                $context.find('[data-add-to-cart]').find('[data-cartbutton-spinner-text]')
                    .text(theme.language.cart_add_to_cart)

                $context.find('[data-product-available]')
                    .removeClass('hidden')
                $context.find('[data-product-unavailable]')
                    .addClass('hidden')

            } else {

                $context.find('[data-product-delivery-estimate]').addClass('hidden')
                $context.find('[data-add-to-cart]').find('[data-cartbutton-spinner-text]')
                    .text(theme.language.cart_sold_out)

                // Variant is sold out.
                $context.find('[data-add-to-cart]')
                    .addClass('bg-grey opacity-50 cursor-not-allowed')
                    .attr('disabled', 'disabled')
                    .fadeTo(200, 0.5);
                
                $context.find('[data-product-available]')
                    .addClass('hidden')

                $context.find('[data-product-unavailable]')
                    .removeClass('hidden')

            }

            // Whether the variant is in stock or not, we can update the price and compare at price.
            let $priceField = $context.find('[data-price-field]');
            if ($context.closest('[data-product-box]').length > 0 ) {
                $priceField = $context.closest('[data-product-box]').find('[data-price-field]');
            }

            if ( variant.compare_at_price > variant.price ) {
                
                $context.parents('[data-product-box]').find('[data-sold-out]').addClass('hidden');
                $context.parents('[data-product-box]').find('[data-sale]').removeClass('hidden');

                $.each($priceField, function(){
                    $(this).html('<s class="product-compare-price text-coral">'+Shopify.formatMoney(variant.compare_at_price, "")+ '</s>&nbsp;<span class="product-price on-sale">'+ Shopify.formatMoney(variant.price, "") +'</span>');
                })

            } else {

                $context.parents('[data-product-box]').find('[data-sold-out]').removeClass('hidden');
                $context.parents('[data-product-box]').find('[data-sale]').addClass('hidden');

                $.each($priceField, function(){
                    $(this).html('<span class="product-price">'+ Shopify.formatMoney(variant.price, "") + '</span>' );
                })

            }
            
        } else {

            // variant doesn't exist.
            $context.find('[data-product-delivery-estimate]').removeClass('hidden')
            $context.find('[data-add-to-cart]')
                .val('Unavailable')
                .addClass('disabled')
                .attr('disabled', 'disabled').fadeTo(200,0.5);

        }
        
        // Update SKU
        theme.variants._updateSku(variant, $context);

        // Update Klarna
        theme.variants._upateKlarna(variant, $context)

    },

    /**
     * Update the SKU 
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateSku: function(variant, $context) {

        if ($context.length > 0) {   
            let $sku = $context.find('[data-product-sku]')
            if ($sku.length > 0) {
                $sku.html(variant.sku)
            }
        }

    },

    /**
     * Klarna updates
     *
     * @param  {variant} variant - Update Klarna
     */
    _upateKlarna: function(variant) {

        let $klarna = $('[data-klarna-installments]')
        if ($klarna.length > 0) {
            let installments = $klarna.data('klarna-installments')
            let price = parseInt(variant.price / installments)
            $klarna.text(Shopify.formatMoney(price, ""));
        }

    },

    /**
     * Hides the spinner and shows the varaints.
     */
    _createUI: function() {
        $('.product-variants').show()
        $('.product-variants-loader').hide()
    },

}